import { Types as DeviceTypes } from '../../actions/device'
import { DateUtils } from '../../utils'
import historyReducer, { initialState as historyInitialState } from './history'

const initialState = {
    history: historyInitialState,
    isFetchingDisplayGroups: false,
    isHistoryWorking: false,
    isWorking: false,
    screenshots: {},
    selectedDevice: null,
    selectedDeviceStatus: {},
    /**
     * @type {import('../../types/DeviceMain').DeviceGroup[]}
     */
    displayGroups: [],
    storeLocations: [],
    /**
     * @type {import('../../types/DeviceMain').Device[]}
     */
    list: [],
}

export default (state = initialState, action) => {
    const { type, payload = {} } = action

    switch (type) {
        case DeviceTypes.API_CALL_FAILURE:
            return {
                ...state,
                isWorking: false,
            }
        case DeviceTypes.FETCH_DEVICE_SCREENSHOT:
            return {
                ...state,
                screenshots: {
                    ...state.screenshots,
                    [payload.uid]: {
                        screenshot: payload.screenshot,
                    },
                },
            }
        case DeviceTypes.FETCH_DEVICE_GROUPS_REQUEST:
            return {
                ...state,
                isFetchingDisplayGroups: true,
            }
        case DeviceTypes.FETCH_DEVICE_GROUPS_FAILURE:
            return {
                ...state,
                isFetchingDisplayGroups: false,
            }
        case DeviceTypes.FETCH_DEVICE_GROUPS_SUCCESS:
            return {
                ...state,
                isFetchingDisplayGroups: false,
                displayGroups: payload.map((group) => ({
                    ...group,
                })),
            }
        case DeviceTypes.FETCH_STORE_LOCATIONS_SUCCESS:
            return {
                ...state,
                storeLocations: payload || [],
            }
        case DeviceTypes.FETCH_SINGLE_DEVICE_REQUEST: {
            return {
                ...state,
                isWorking: true,
                selectedDevice: null,
            }
        }
        case DeviceTypes.FETCH_SINGLE_DEVICE_SUCCESS:
            return {
                ...state,
                isWorking: false,
                selectedDevice: {
                    ...payload,
                    migrated_at: payload.migrated_at && DateUtils.UTCDateToTimestamp(payload.migrated_at),
                    four_k: payload["4k_resolution"],
                },
            }
        case DeviceTypes.FETCH_DEVICE_STATUS_REQUEST:
            return {
                ...state,
                isWorking: true,
                selectedDeviceStatus: {},
            }
        case DeviceTypes.FETCH_DEVICE_STATUS_SUCCESS: {
            const { device, store_code, date, apk_version, hdmi, wired } = (payload || [])[0] || {}
            return {
                ...state,
                isWorking: false,
                selectedDeviceStatus: {
                    device,
                    store_code,
                    date,
                    apk_version,
                    hdmi: hdmi === '1',
                    wired,
                },
            }
        }
        case DeviceTypes.FETCH_DEVICES_SUCCESS: {
            // Merge devices to avoid overwriting when multiple fetches (e.g. different filters) run
            const existing = state.list || []
            const incoming = payload || []
            const byId = {}
            existing.forEach((dev) => {
                if (dev?.id) {
                    byId[dev.id] = dev
                }
            })
            incoming.forEach((dev) => {
                if (dev?.id) {
                    byId[dev.id] = dev
                }
            })

            return {
                ...state,
                list: Object.values(byId),
            }
        }
        case DeviceTypes.CLEAR_DEVICES_LIST: {
            return {
                ...state,
                list: initialState.list,
            }
        }
        default:
            const newHistoryState = historyReducer(state.history, action)

            if (newHistoryState !== state.history) {
                return {
                    ...state,
                    history: newHistoryState,
                }
            }

            return state
    }
}

/**
 * Get selected device history
 * @param {Object} state
 */
const getDeviceHistory = (state) => state.device.deviceHistory

/**
 * Is device history being loaded
 * @param {Object} state
 */
const isHistoryWorking = (state) => state.device.isHistoryWorking

/**
 * 
 * @param {import('..').RootState} state 
 * @returns {import('../../types/DeviceMain').Device[]}
 */
const selectDevicesList = state => state.device.list

export { getDeviceHistory, isHistoryWorking, selectDevicesList }
